import React, { useState } from "react";
import styled from "styled-components";
import { Button, CircularProgress } from "@mui/material";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "axios";
import moment, { MomentInput } from "moment";
import Title from "../../custom/Title";
import useService from "../../../hooks/useService";
import { getDocumentsReport } from "../../../services/Reports";
// import { errorToast } from "../../../../utils/constants";

const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  border-radius: 7px;
  margin-bottom: 20px;
  margin-top: 20px;
`;

const ComponentContainer = styled.div`
  height: calc(100vh - 64px);
  width: 100%;
  background-color: white;
  padding: 10px 15px 10px 15px;
`;

const CenterLoadingContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CalendarContainer = styled.div`
  height: calc(100% - 43px);
  width: 100%;
  overflow-y: auto;
`;

const DocumentsReport = () => {
  let sessionId: any = localStorage.getItem("sessionId")
  const [loading, setLoading] = useState(false)
  const [selectedDate, setSelectedDate] = useState<any>()
  const { execute } = useService()


  const handleDateClick = (data: any) => {
    setSelectedDate(data)
  }

  const downloadDocumentsReport = async () => {
    try {
      setLoading(true)
      let date = moment(selectedDate.date as MomentInput)
      console.log('selectedDate', selectedDate)
      console.log('date', date)
      const params = {
        // sessionId: sessionId,
        Date: date
      }
    //   const { data } = await axios.post("/api/pvcReports/getDocumentsReport", params)
      const { data } = await execute(() => getDocumentsReport({params}))
      console.log(data,'report_Data_fetched')
      if (data?.error) alert('Documents report not found!')
      else {
        let fileUrl = data?.data?.url
        window.open(fileUrl, '_blank')
      }

      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error('error ::', error)
      alert('Unable to get documents report!')
    }
  }

  const headerContainer = () => {
    return (
      <HeaderContainer>
        <Button
          variant="contained"
          onClick={downloadDocumentsReport}
          endIcon={<DownloadIcon />}
          disabled={!selectedDate || loading}
        >
          Download Report
        </Button>
      </HeaderContainer>
    )
  }

  const renderLoading = () => {
    return (
      <CenterLoadingContainer>
        <CircularProgress color="primary" />
      </CenterLoadingContainer>
    )
  }

  const renderContent = () => {
    // let today = new Date()
    // let tomorrow = new Date(today)
    // tomorrow.setDate(today.getDate() + 1)
    // const disbaleFrom = today.toISOString().split("T")[0]

    let today = new Date();
    let offset = 5.5 * 60; // IST is UTC+5:30, so 5.5 hours in minutes
    let localTime = new Date(today.getTime() + (offset * 60 * 1000));
    let tomorrow = new Date(localTime);
    tomorrow.setDate(today.getDate() + 1);
    const disableFrom = tomorrow.toISOString().split("T")[0];

    return (
      <>
        <CalendarContainer>
          <FullCalendar
            buttonText={{ today: "Today" }}
            plugins={[dayGridPlugin, interactionPlugin]}
            validRange={{ end: disableFrom }}
            initialView="dayGridMonth"
            height="100%"
            selectable
            dragScroll={false}
            dateClick={handleDateClick}
          />
        </CalendarContainer>
      </>
    )
  }

  return (
    <>
    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>TI DC Summary Report</Title>
      {headerContainer()}
      <ComponentContainer>
        {loading ? renderLoading() : renderContent()}
      </ComponentContainer>
    </>
  )
}

export default DocumentsReport
